import * as yup from "yup";

export const estimateSchema = yup.object().shape({
	driverAge: yup.number().required("Please enter your Age").min(17, "Too young").max(100, "Too old"),
	noClaimsDuration: yup
		.number()
		.min(0, "Input Error")
		.required("Please enter the number of years that you made a claim")
		.test("maxClaims", "Too young for a no claims bonus", function (value) {
			const { driverAge } = this.parent;
			return (value as number) <= driverAge - 17;
		}),
	postcode: yup
		.string()
		.required("Please enter your Postcode")
		.min(5, "Character must be between 5 and 10 characters.")
		.max(10, "Character must be between 5 and 10 characters."),
});

export const estimateSchemaGrey = yup.object().shape({
	registration: yup
		.string()
		.required("Please enter your registration")
		.min(0, "Characters must be between 0 and 10 characters.")
		.max(10, "Characters must be between 0 and 10 characters."),
	driverAge: yup.number().required("Please enter your Age").min(17, "Too young").max(100, "Too old"),
	noClaimsDuration: yup
		.number()
		.min(0, "Input Error")
		.required("Please enter the number of years that you made a  claim")
		.test("maxClaims", "Too young for a no claims bonus", function (value) {
			const { driverAge } = this.parent;
			return (value as number) <= driverAge - 17;
		}),
	postcode: yup
		.string()
		.required("Please enter your Postcode")
		.min(5, "Character must be between 5 and 10 characters.")
		.max(10, "Character must be between 5 and 10 characters."),
	renewalMonth: yup.string().required("Please enter your renewal month"),
});
